import { render, staticRenderFns } from "./MobileQuickService.vue?vue&type=template&id=8738ab94&scoped=true"
import script from "./MobileQuickService.vue?vue&type=script&lang=js"
export * from "./MobileQuickService.vue?vue&type=script&lang=js"
import style0 from "./MobileQuickService.vue?vue&type=style&index=0&id=8738ab94&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8738ab94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8738ab94')) {
      api.createRecord('8738ab94', component.options)
    } else {
      api.reload('8738ab94', component.options)
    }
    module.hot.accept("./MobileQuickService.vue?vue&type=template&id=8738ab94&scoped=true", function () {
      api.rerender('8738ab94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/mobile/MobileQuickService.vue"
export default component.exports